module.exports = __webpack_public_path__ + "img/img5777_comp.b0745734.jpg";